import React from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, ArrowRight, Cpu } from "lucide-react";
import { Breadcrumb, GradientPanel } from "../components/common";
import { playbook } from "../data/scenarios";

const Scenarios = () => {
  const navigate = useNavigate();
  const go = (p) => {
    if (p.route) return navigate(p.route);
    if (p.action === "cancel") return navigate("/a/status");
    const qs = [];
    if (p.scenario) qs.push(`preset=${p.scenario}`);
    if (p.docType) qs.push(`doc=${p.docType}`);
    navigate(`/a/e-invoice${qs.length ? "?" + qs.join("&") : ""}`);
  };
  return (
    <div>
      <Breadcrumb items={[{ label: "Dashboard", path: "/a/dashboard" }, { label: "Scenarios & Playbook" }]} />
      <GradientPanel>
        <div className="flex items-start gap-3">
          <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center text-white shrink-0"><BookOpen size={20} /></div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Scenarios &amp; Playbook</h1>
            <p className="text-sm text-gray-500 mt-1">Every supported e-invoicing scenario - and exactly which agents handle it. Click any card to run it live.</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mt-6">
          {playbook.map((p) => (
            <button key={p.id} onClick={() => go(p)} className="text-left bg-white rounded-2xl border border-gray-100 card-soft hover-lift p-4 flex flex-col">
              <h3 className="font-semibold text-gray-900">{p.title}</h3>
              <p className="text-sm text-gray-500 mt-1 flex-1">{p.desc}</p>
              <ol className="mt-3 space-y-1">
                {p.steps.map((s, i) => (
                  <li key={i} className="flex items-start gap-2 text-xs text-gray-600"><span className="w-4 h-4 rounded-full bg-indigo-50 text-indigo-600 text-[10px] flex items-center justify-center shrink-0 mt-0.5">{i + 1}</span>{s}</li>
                ))}
              </ol>
              <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-50">
                <span className="inline-flex items-center gap-1 text-[11px] text-gray-400"><Cpu size={12} /> Agents {p.agents.join(", ")}</span>
                <span className="text-xs text-indigo-600 font-medium inline-flex items-center gap-1">Run <ArrowRight size={13} /></span>
              </div>
            </button>
          ))}
        </div>
      </GradientPanel>
    </div>
  );
};

export default Scenarios;
